module.exports = "/_next/static/images/fees_optimization-0b482a4f1c3202351e1e9340ab3dc5d1.png";